import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/index'; // Initialize i18n (EN + AR) before App renders
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <GoogleOAuthProvider clientId="893035964884-8ivsbh9jap70vedacajsm4naj1vo89mb.apps.googleusercontent.com">
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </GoogleOAuthProvider>
);

reportWebVitals();
